var symphony = symphony || {};

;
(function () {

	symphony.stickyNavPrevScroll = 0;
	symphony.stickyNav = function () {
		if (document.body.classList.contains('admin-body')) {
			return;
		}

		if (document.body.classList.contains('kroc-theme')) {

			$(window).on('scroll', _.throttle(setNav, 50));

			setNav();

			function setNav() {
				var scroll = $(window).scrollTop();
				var headerHeight = $('header').outerHeight();

				if (scroll > symphony.stickyNavPrevScroll && document.body.classList.contains('header-isSticky')) {
					//scrolling down

					if (scroll < headerHeight) {
						document.body.classList.remove('header-isSticky');
						document.body.classList.remove('header-isSticking');
					} else {
						document.body.classList.add('header-unSticking');
						setTimeout(function () {
							document.body.classList.remove('header-isSticky');
							setTimeout(function () {
								document.body.classList.remove('header-unSticking');
							}, 350);
						}, 50);
					}
				} else if (scroll < symphony.stickyNavPrevScroll && scroll > headerHeight && !document.body.classList.contains('header-isSticky')) {
					//scrolling up

					document.body.classList.add('header-isSticking');
					setTimeout(function () {
						document.body.classList.add('header-isSticky');
						setTimeout(function () {
							document.body.classList.remove('header-isSticking');
						}, 350);
					}, 50);
				}

				symphony.stickyNavPrevScroll = scroll;
			}

		} else {

			if ($('.givingToolbar-toolbar:visible').length > 0 && !$('body').hasClass('hasGivingToolbar')) {
				$('body').addClass('hasGivingToolbar');
			}

			var alwaysSticky = $('body').hasClass('always-isSticky');
			console.log('alwaysSticky', alwaysSticky);
			function isFirstElement(parent, child) {
				return $(`.first-property + ${parent} > ${child}:first-child`).length > 0;
			}
			function isSecondElement(parent, child) {
				return $(`.first-property + ${parent} > ${child}:nth-child(2)`).length > 0;
			}

			var heroIsFirstProperty = $('.first-property + .heroContainer').length > 0 || 
				isFirstElement('#page', '.heroContainer') ||
				isFirstElement('.landingpage-container', '.heroContainer') ||
				(isFirstElement('.landingpage-container', 'style') && isSecondElement('.landingpage-container', '.heroContainer'));
			console.log('heroIsFirstProperty', heroIsFirstProperty);

			// if there's no hero image or it's not the first property, just make everything sticky
			if ($('.heroContainer').length <= 0 || ($('body').hasClass('localSite') && !heroIsFirstProperty && !$('body').hasClass('home'))) {
				alwaysSticky = true;
				console.log('alwaysSticky', alwaysSticky);
			}

			// if it's not a local site homepage, ministry page or ways to give page, just make everything sticky
			if ($('body').hasClass('localSite') && !$('body').hasClass('home') && !$('body').hasClass('ministry') && !$('body').hasClass('waystogive')) {
				alwaysSticky = true;
				console.log('alwaysSticky', alwaysSticky);
			}

			if (!alwaysSticky && heroIsFirstProperty && $('body').hasClass('hasGivingToolbar') && $('body').hasClass('localSite') && ($('body').hasClass('ministry') || $('body').hasClass('waystogive'))) {
				var $heroProperty = $('.first-property + .heroContainer').length > 0 ? $('.first-property + .heroContainer') : $('.first-property + #page > .heroContainer:first-child');
				$heroProperty.after($('.givingToolbar-toolbar'));
			}

			var $handle = $('.givingToolbar-toolbar').length > 0 ? $('.givingToolbar-toolbar') : $('.section').eq(0);

			if (!$handle || $handle.length == 0) {
				return;
			}

			// if the handle is at the top of the page, just make everything sticky
			if ($handle.offset().top == 0) {
				alwaysSticky = true;
			}

			console.log('alwaysSticky', alwaysSticky);

			if (alwaysSticky) {
				$('body').addClass('header-isSticky');
				$('body').addClass('givingToolbar-isSticky');
				$('body').addClass('always-isSticky');
				return;
			}

			$(window).on('scroll', _.throttle(setNav, 50));

			setNav();

			function setNav() {
				var scroll = $(window).scrollTop();
				if (scroll <= 0) {
					if (!symphony.config.utilities.expandingHeader.hasClass('isExpanded') && !$('body').hasClass('always-isSticky')) {
						$('body').removeClass('header-isSticky');
						$('body').removeClass('givingToolbar-isSticky');
					}
				} else if (!$('body').hasClass('header-isSticky') && $handle.offset().top - scroll <= $('.globalHeader').outerHeight()) {
					$('body').addClass('header-isSticky');
					$('body').addClass('givingToolbar-isSticky');
				}
			}
		}

	};

})();
